import {Type} from 'main.core';

export class Kalendar
{
	constructor(options = {name: 'Kalendar'})
	{
		this.name = options.name;
	}

	setName(name)
	{
		if (Type.isString(name))
		{
			this.name = name;
		}
	}

	getName()
	{
		return this.name;
	}
}